export default {"src":"/_next/static/media/SuperwallLogo.32892999.svg","height":22,"width":157,"blurWidth":0,"blurHeight":0};